// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 此处后端没有提供注释 PUT /api/adverse */
export async function adverseControllerUpdate(
	body: API.AdverseUpdateRequest,
	options?: { [key: string]: any }
) {
	return request<boolean>('/api/adverse', {
		method: 'PUT',
		headers: {
			'Content-Type': 'application/json',
		},
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 GET /api/adverse/${param0} */
export async function adverseControllerGet(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.AdverseControllerGetParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<API.AdverseViewResponse>(`/api/adverse/${param0}`, {
		method: 'GET',
		params: { ...queryParams },
		...(options || {}),
	});
}

/** 此处后端没有提供注释 POST /api/adverse/${param0} */
export async function adverseControllerCreate(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.AdverseControllerCreateParams,
	body: API.AdverseCreateRequest,
	options?: { [key: string]: any }
) {
	const { hubId: param0, ...queryParams } = params;
	return request<boolean>(`/api/adverse/${param0}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		params: { ...queryParams },
		data: body,
		...(options || {}),
	});
}

/** 此处后端没有提供注释 DELETE /api/adverse/${param0}/${param1} */
export async function adverseControllerDelete(
	// 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
	params: API.AdverseControllerDeleteParams,
	options?: { [key: string]: any }
) {
	const { hubId: param0, id: param1, ...queryParams } = params;
	return request<boolean>(`/api/adverse/${param0}/${param1}`, {
		method: 'DELETE',
		params: { ...queryParams },
		...(options || {}),
	});
}
